<template>
    <div class="bg">
        <div class="wrap">
            <div class="login">
                <div class="inputwrap">
                    <el-input
                        placeholder="请输入账号"
                        v-model="username"
                    >
                    </el-input>
                </div>
                <div class="inputwrap">
                    <el-input
                        type="password"
                        placeholder="请输入密码"
                        v-model="password"
                    >
                    </el-input>
                </div>
                <div class="buttonnwrap">
                    <el-button style="display:none"
                        type="primary"
                        @click='login()'
                    >登录</el-button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {Message} from 'element-ui';
export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    login() {
      if (this.username == '' && this.password == '') {
        Message({
          message: '账号或密码不能为空',
          type: 'warning',
          center: true,
          showClose: false,
        });
      } else {
        this.axios
          .post('http://www.yzparking.cn/mis/member/login', {
            phone: this.username,
            password: this.password,
          })
          .then(res => {
            if (res.data.code == 200) {
            } else {
              Message({
                message: '账号或密码错误！',
                type: 'warning',
                center: true,
                showClose: false,
              });
            }
          })
          .catch(err => {
            Message({
              message: '网络错误',
              type: 'warning',
              center: true,
              showClose: false,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.bg {
  height: 100vh;
  background-image: url('../assets/img/login.png');
  background-size: 100% 100%;
}
.wrap {
  margin: 0 auto;
  text-align: center;
  padding-top: 30%;

  overflow-y: hidden;
  overflow-x: hidden;
  overflow: hidden;
}
.inputwrap {
  margin: 0 auto;
  width: 85%;
}
input:focus {
  border: 1px solid red;
}
button {
  margin-top: 50px;
  width: 90%;
  font-size: 16px;
  font-weight: normal;
}
.login {
  background-color: #fff;
  margin: 0 auto;
  width: 90%;
  padding: 50px 0;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue